<template>
  <v-container class="ts-team">
    <v-row no-gutters>
      <v-col cols="auto"><v-btn icon @click="$router.push({name:'Games'})"><v-icon>mdi-chevron-left</v-icon></v-btn></v-col>
      <v-col>
        <v-text-field v-model="gameName"
                      solo hide-details
                      @change="updateGame"
        />
      </v-col>
    </v-row>

    <v-expansion-panels v-model="panels">
      <v-expansion-panel key="team-panel">
        <v-expansion-panel-header>
          팀설정
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row :class="isMobile && 'flex-column'">
            <v-col cols="md-3 col-sm-12">
              <v-btn class="col-sm-12"
                     @click="selectedCandidates.splice(0,selectedCandidates.length,...players)">
                Candidates(클릭시 전부추가)
              </v-btn>
            </v-col>
            <v-col cols="md-9 col-sm-12">
              <v-item-group
                  v-model="selectedCandidates"
                  multiple
              >
                <v-item
                    v-for="(player,i) in players" :key="i"
                    v-slot:default="{toggle,active}"
                    :value="player"
                >
                  <v-btn
                      :input-value="active"
                      :text="active"
                      tile
                      @click="toggle"
                      :color="player.color"
                      dark
                  >{{ player.name }}
                  </v-btn>
                </v-item>
              </v-item-group>
            </v-col>
          </v-row>
          <v-row :class="isMobile && 'flex-column'">
            <v-col cols="md-3 col-sm-12">
              <v-btn class="col-sm-12" @click="selectedCandidates = []">Players(클릭시 전부삭제)</v-btn>
            </v-col>
            <v-col cols="md-9 col-sm-12">
              <v-item-group>
                <ts-player
                    v-for="(player,i) in selectedCandidates" :key="player.name"
                    big :player="player"
                    @click="selectedCandidates.splice(i,1)"
                >
                  <template v-if="player.order !== undefined" v-slot:prepend>{{
                      `${player.order - -1}.`
                    }}
                  </template>
                </ts-player>
              </v-item-group>
            </v-col>
          </v-row>
          <!-- modes -->
          <v-row>
            <v-col cols="auto">
              <v-btn v-if="selectedCandidates.length >= 4" small color="success" outlined tile
                     @click="appendMatch(makeNormalMatches)">티밍:일반
              </v-btn>
              <v-btn v-if="selectedCandidates.length === 4" small color="warning" outlined tile
                     @click="appendMatch(makeCombinationMatches)">티밍:조합
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-switch v-model="randomTeam" label="티밍랜덤"></v-switch>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <!-- 대진표 -->
    <ts-record-table
        for-teaming
        editable
        :selectable="!isMobile"
        hide-default-footer
        :sort="false"
        :players="players"
        :records.sync="teamingResults"
        :items-per-page.sync="itemsPerPage"
        disable-sort
        @click:delete="putInstance({date:$day().dateTimeFormat()})"
        @click:save="putInstance"
    >
      <template v-slot:title>
        <v-btn outlined @click="dialogRank = true">
          <v-icon>mdi-ab-testing</v-icon>
        </v-btn>
        <small v-if="date" style="margin-left:5px;">{{ date }}</small>
      </template>
    </ts-record-table>
    <div class="d-flex">
      <v-btn
          :disabled="!intent.newRecords || !intent.newRecords.length"
          class="flex-grow-1" @click="confirmData">확정하기</v-btn>
    </div>
    <v-dialog v-model="dialogRank">
      <v-img class="absolute fill-parent" style="z-index:-1" :src="intent.background"></v-img>
      <v-row no-gutters style="background-color: white;height:50px;">
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <v-btn icon @click="dialogRank=false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row no-gutters style="overflow-y:auto; height:calc(100% - 50px);">
        <v-col>
          <ts-ranking
              style="background: rgba(255,255,255,0.5)"
              :players="players"
              :records="recordHasResults"
          >
          </ts-ranking>
        </v-col>
      </v-row>
    </v-dialog>
    <manage v-show="false" ref="manage" :record="intent.newRecords"></manage>
    <mileage v-show="false" ref="mileage"></mileage>
  </v-container>
</template>


<style lang="scss">
$back-white: rgba(255, 255, 255, 0.5) !important;
.ts-team {
  .row {
    align-items: center;
  }

  .ts-record-table {
    .ts-record-table__item {
      background-color: white;
    }

    .ts-record-table__item--has-date {
      background-color: #aaaaaa;

      .v-data-table__mobile-row {
        background-color: #f3f3f3;
      }
    }

    .v-card__title {
      z-index: 1;
      position: sticky;
      top: 0;
      border-bottom: 1px solid grey;
      background-color: #f3f3f3;
    }
  }
}
</style>

<script>
// import $ from 'jquery';
import {getPlayers} from "@/api/player";
import TsPlayer from "@/components/TsPlayer";
import TsRecordTable from "@/components/TsRecordTable";
import {getRandomIntArray} from "@/util/nativeHelper";
import {getGameInstance, putGameInstance} from "@/api/instance";
import TsRanking from "@/components/TsRanking";
import {mapGetters} from "vuex";
import Manage from "@/views/Manage";
import Mileage from "@/views/Mileage";
import {getGame, updateGame} from "@/api/game";

export default {
  name: "Game",
  components: {Mileage, Manage, TsRanking, TsRecordTable, TsPlayer},
  props: ['picker', 'intent', 'id'],
  data: function () {
    return {
      totalRecord: [],
      panels: [],

      randomTeam: false,
      selectedCandidates: [],
      teamingResults: [],
      date: '',

      dialogRank: false,
      interval: null,
      itemsPerPage: -1,
      game: null,
    }
  },
  watch: {
    dialogRank(val) {
      if (val) {
        this.$router.push({hash: 'dialogRank'})
      }
    },
    teamingResults(val) {
      this.intent.newRecords = (val || []).filter(r => r.date);
      this.calculateSoloTop()
    },
    players: {
      deep:true,
      handler(){
        this.updateGame()
      }
    }
  },
  computed: {
    ...mapGetters(['loginRequestCount', 'kakaoData']),
    isLogin() {
      this.loginRequestCount;
      return this.$session.exists()
    },
    recordHasResults() {
      return (this.teamingResults || []).filter(r => {
        const result = r.result || [0, 0];
        return !!(result[0] - result[1])
      }).map(r => {
        const newRes = {...r};
        if (r.result[1] > r.result[0]) {
          const temp = newRes.losers;
          newRes.losers = newRes.winners;
          newRes.winners = temp
        }
        return newRes
      })
    },
    players: {
      set(p){this.game.players = p},
      get(){return this.game?.players || []}
    },
    gameName: {
      set(name){this.game.name = name},
      get(){return this.meta.name}
    },
    meta(){
      return this.game || {id: this.id}
    }
  },
  async mounted() {
    await this.getGame();
    const _self = this;
    window.onhashchange = function () {
      _self.dialogRank = false;
    };
    this.getPlayers();
    this.interval = setInterval(this.getInstance, 3000);
    await this.getInstance();

    this.$emit('update:picker', false)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    async confirmData(){
      await this.$confirm('확정하시겠습니까?')
      const result = await this.$refs.manage.handleClickSave()
      if(result){
        const mileageResult = this.$refs.mileage.calculateMileageFromRecords(result)
        await this.$confirm(this.$refs.mileage.extractMileageString(mileageResult)+"\n를 마일리지에 추가하시겠습니까?")
        this.$refs.mileage.addMileageResult(mileageResult)
        await this.$refs.mileage.save()
        await this.putInstance({
          date: this.$day().dateTimeFormat() + ' 확정됨',
          message: '확정 반영되었습니다',
          teamingResults: []
        })
      }
    },
    makeCombinationMatches() {
      // FIXME: 4인용만 가능
      const players = this.selectedCandidates;
      const results = [];
      for (let i = 1; i < players.length; i++) {
        const team1 = [0, i]
        const team2 = [0, 1, 2, 3].filter(idx => !team1.includes(idx))
        results.push(
            this.makeMatch(i, team1.map(idx => players[idx]), team2.map(idx => players[idx])));
      }
      this.panels = []
      return results
    },
    makeNormalMatches() {
      const windowDelta = {
        4: () => 0,
        5: () => 1,
        6: () => 4,
        7: () => 4,
        8: (i) => 4 + i % 2,
        default: () => 1
      };
      const players = this.selectedCandidates;
      const results = [];
      let window = 0;
      for (let i = 0; i < players.length; i++) {
        const idxForTeam = (this.randomTeam ? getRandomIntArray(4) : [0, 1, 2, 3]).map(
            idx => (idx - -window) % players.length);
        results.push(this.makeMatch(i, [players[idxForTeam[0]], players[idxForTeam[1]]],
            [players[idxForTeam[2]], players[idxForTeam[3]]]));
        window += players.length in windowDelta ? windowDelta[players.length](i)
            : windowDelta.default(i)
      }
      this.panels = []
      return results
    },

    async appendMatch(matchMaker, title) {
      if (!await this.queuePlayers(title)) {
        return;
      }
      const matches = matchMaker()
      this.teamingResults = this.teamingResults.filter(r => r.date).concat(matches);
      this.putInstance({date: this.$day().dateTimeFormat()})
    },

    async queuePlayers(title) {
      if ((this.teamingResults || []).filter(r => !r.date).length && !await this.$confirm(
          (title || '') + "저장되지 않은 결과는 사라집니다?")) {
        return false;
      }
      getRandomIntArray(this.selectedCandidates.length).forEach(
          (order, i) => this.selectedCandidates[i].order = order);
      this.selectedCandidates.sort((a, b) => Number(a.order) - Number(b.order));
      return true
    },
    makeMatch(i, team1, team2) {
      return {
        key: `${new Date().getTime()}-${i}`,
        boksik: true,
        winners: team1.map(p => p.name || p).sort(),
        losers: team2.map(p => p.name || p).sort()
      }
    },
    calculateSoloTop() {
      if (!this.players.length) {
        return
      }
      const playerCounter = Object.fromEntries(
          this.players.map(({name}) => [name, {win: 0, lose: 0}]));
      this.teamingResults.forEach(record => {
        if (!record.result) {
          return;
        }
        if (record.result[1] > record.result[0]) {
          record.losers.forEach(loser => {
            playerCounter[loser].win++
          });
          record.winners.forEach(winner => {
            playerCounter[winner].lose++
          })
        } else if (record.result[0] > record.result[1]) {
          record.winners.forEach(winner => {
            playerCounter[winner].win++
          });
          record.losers.forEach(loser => {
            playerCounter[loser].lose++
          })
        }
      });

      function ratio({win, lose}) {
        return win * 100 / (win - -lose || 100)
      }

      const sorted = Object.entries(playerCounter).map(
          ([name, count]) => ({name, ...count, ratio: ratio(count)})).sort(
          (a, b) => b.ratio - a.ratio || b.win - a.win);
      const winner = this.players.find(p => p.name === sorted[0].name);
      if (sorted[0] && sorted[0].win && winner
          && winner.meta) {
        this.intent.background = winner.meta.image;
      } else {
        this.intent.background = false;
      }
      return winner
    },

    putInstance(options) {
      return putGameInstance(this.meta, {
        randomTeam: this.randomTeam,
        selectedCandidates: this.selectedCandidates,
        teamingResults: (this.teamingResults || []).filter(r => !r.deleted),
        date: this.date,
        ...options
      }).then(() => {
        this.getInstance();
        if(!options?.noMessage)
          this.$alert(options?.message || '저장되었습니다.')
      })
    },
    getInstance() {
      if (!this.isLogin) {
        return this.$store.dispatch('auth/openLoginDialog')
      }
      return getGameInstance(this.meta).then(data => {
        if(!data) return this.putInstance({noMessage: true})
        data = data.contents
        if (data && this.date !== data.date) {
          // 전부 덮어쓰기
          const {randomTeam, selectedCandidates, teamingResults, date} = data;
          Object.assign(this, {
            randomTeam, teamingResults: teamingResults || [], date,
            selectedCandidates: (selectedCandidates || []).map(_p => {
              const newP = {...this.players.find(_tp => _tp.name === _p.name)};
              return {...newP, ..._p, meta: newP.meta}
            })
          })
        } else {
          // 전적만 업데이팅
          const newResults = data.teamingResults || [];
          const newResultsMap = Object.fromEntries(newResults.map(result => [result.key, result]));

          this.teamingResults = this.teamingResults.map((tr) => {
            if (newResultsMap[tr.key] && newResultsMap[tr.key].date) {
              tr = newResultsMap[tr.key]
            }
            delete newResultsMap[tr.key];
            return tr
          });

          for (const key in newResultsMap) {
            this.teamingResults.push(newResultsMap[key])
          }
        }
      })
    },
    getPlayers() {
      return getPlayers().then(data => (this.players = data))
    },
    updateGame(){
      return updateGame(this.meta)
    },
    getGame(){
      if(this.id)
        return getGame(this.id).then(game => this.game = game)
      else
        throw 'error'
    }
  }
}
</script>
